exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".addarticle-1{fill:#fff}.addarticle-2,.addarticle-6{fill:#72cac2}.addarticle-3{fill:#fbe57f}.addarticle-4{fill:#1e4e69}.addarticle-5{opacity:.419}.addarticle-6{stroke:#fff}\n", ""]);
